import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Button, Center, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text, useDisclosure } from '@chakra-ui/react';
import React from 'react';
import { useDocument } from 'react-firebase-hooks/firestore';
import { Redirect, useParams } from 'react-router-dom';
import { firestore } from '../../../../utils/firebase';
import { getScreenWidth } from '../../../../utils/mobile';
import ImageListViewer from '../../../Shared/FileListViewer/FileListViewer';
import Checklist from '../../Checklist/Checklist';
import AddTask from '../../Task/AddTask/AddTask';
import EditJobBtn from '../JobForm/EditJob/EditJobBtn';
import { JobInfoHelpButton } from './JobInfoHelpButton';

export function JobInfoPage() {
    const { isOpen: isAddTaskOpen, onOpen: onAddTaskOpen, onClose: onAddTaskClose } = useDisclosure()
    const { tenantID, JobID } = useParams<any>();

    const [value, loading, error] = useDocument(
        firestore.doc(`tenants/${tenantID}/jobs/${JobID}`),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );

    React.useEffect(() => {
    }, [loading])

    return (
        <Flex flexDirection={{ base: "column", md: "row" }}
        // SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 2, sm: 0 }}
        >
            <Box
                mr="4"
                mb="6"
                width="300px"
            >
                <JobInfoHelpButton />

                <Button
                    boxShadow="sm" width="100%" mt="2" borderRadius="0.5em"
                    background="white"
                    cursor="pointer" color="gray.800" paddingLeft="4" onClick={onAddTaskOpen}>
                    <Center><Box borderWidth="3px" w="4" h="4" borderRadius="0.25em" marginRight="1" ></Box></Center>
                    Add a new task
                </Button>

                <Button boxShadow="sm" width="100%" mt="2" borderRadius="0.5em" background="white" cursor="pointer" color="gray.800" paddingLeft="4" >
                    View Employee Checklist
                </Button>


                <EditJobBtn
                    renderBtn={() => <Button boxShadow="sm" width="100%" mt="2" borderRadius="0.5em" background="white" cursor="pointer" color="gray.800" paddingLeft="4" >
                        <Text fontWeight="semibold">Edit Job</Text>
                    </Button>
                    }
                    job={value?.data()}
                    isEdit isClickable />

                <Modal isOpen={isAddTaskOpen} onClose={onAddTaskClose}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Add a new task</ModalHeader>

                        <ModalCloseButton />
                        <ModalBody>
                            <AddTask onClosefn={onAddTaskClose} key="add" />
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </Box>

            <Box style={{ zoom: (getScreenWidth() > 400 ? 0.9 : 0.8) }}>
                <div className="marvel-device s5 white">
                    <div className="top-bar"></div>
                    <div className="sleep"></div>
                    <div className="camera"></div>
                    <div className="sensor"></div>
                    <div className="speaker"></div>
                    <div className="screen"                >
                        <Box
                            w="100%"
                            maxW={"320px"}
                            minW="100%"
                            minH="80vh"
                            overflowY="scroll"
                            id="style-4"
                            // p="2"
                            marginLeft={0}
                            bg="gray.50"
                            boxShadow="xl"
                            borderWidth="2px"
                            borderColor="gray.400"
                            h="568px"
                        // borderRadius="0.5em"
                        >
                            {/* Mobile phone content */}

                            {/* Job info */}
                            {/* Progress bar */}
                            {/* <Box bg="blue.800" boxShadow="md" padding="2" paddingTop="1" borderRadius="0.25em" mt="3">
                    <Text fontSize="0.8em" color="white" fontWeight="semibold">0/0 Done</Text>
                    <Progress borderRadius="0.1em" value={0} size="xs" colorScheme="blue" bg="black" />
                </Box> */}

                            <Box
                                p="4" color="blue.800"
                                bg="white"
                                borderRadius="0 0 2em 2em"
                            // background="blue.800"
                            // boxShadow="md"
                            // mt="2"
                            >
                                <Box >
                                    {(!loading && !value?.data()) && <Redirect to="/login" />}
                                    <Accordion defaultIndex={[0]} allowMultiple>
                                        <AccordionItem border="none" borderWidth="0" >
                                            <h2>
                                                <AccordionButton>
                                                    <Box fontWeight="bold" flex="1" textAlign="left">
                                                        Job Information
                                                    </Box>
                                                    <AccordionIcon />
                                                </AccordionButton>
                                            </h2>
                                            <AccordionPanel pb={4}>
                                                <Text fontSize="0.9em" fontWeight="semibold"> {value?.data()?.Title}'s Checklist</Text>
                                                <Text fontWeight="bold"> {value?.data()?.CustomerName} </Text>
                                                <Text fontSize="0.8em"> {new Date(value?.data()?.StartDateTime.toDate()).toLocaleDateString()}</Text>
                                                <Text fontSize="0.8em"> {new Date(value?.data()?.StartDateTime.toDate()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - {new Date(value?.data()?.EndDateTime.toDate()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                                                <Text hidden={!value?.data()?.Note}>Notes: {value?.data()?.Note} </Text>
                                                <ImageListViewer fileArray={value?.data()?.JobFiles} />
                                            </AccordionPanel>
                                        </AccordionItem>
                                    </Accordion>
                                </Box>
                                <Checklist />

                            </Box>

                        </Box>
                    </div>
                    <div className="home"></div>
                </div>
            </Box>
        </Flex >
    );
}
